var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBackground32ReadMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0303 6.53033C17.3232 6.23744 17.3232 5.76256 17.0303 5.46967L12.2574 0.696699C11.9645 0.403806 11.4896 0.403806 11.1967 0.696699C10.9038 0.989593 10.9038 1.46447 11.1967 1.75736L15.4393 6L11.1967 10.2426C10.9038 10.5355 10.9038 11.0104 11.1967 11.3033C11.4896 11.5962 11.9645 11.5962 12.2574 11.3033L17.0303 6.53033ZM0.5 6.75H16.5V5.25H0.5V6.75Z",
    fill: "#21244B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBackground32ReadMore);
export default __webpack_public_path__ + "static/media/arrow-right-background3_2-read-more.e55c80136f3a92ea6e864b132b87651b.svg";
export { ForwardRef as ReactComponent };